import React from "react";
import EmbedVideo from "./embed-video";
import "./gallery.scss"
import PhotoAlbum from "./photo-album";
import { SebiArusLargeImg2022, SebiArusLargeImg2023, SebiArusMiniImg2022, SebiArusMiniImg2023 } from "./photos";
import { PhotoColumn } from "../../components/photo-column";
import sema1 from "../../assets/Sema/sema-1.jpg";
import sema2 from "../../assets/Sema/sema-2.jpg";
import sema3 from "../../assets/Sema/sema-3.jpg";

const Gallery = (props: any) => {
    return (
        <section className="gallery-section">
            <h3 className="seciton-title">VİDEOLAR</h3>
            <div className="gallery-section_videos">
                <EmbedVideo embedId="NUMi2cl4Dqc" />
                <EmbedVideo embedId="jNSOZdHXlHs" />
            </div>

            <h4 className="seciton-title">2023 ŞEB-İ ARUS PROGRAMINDAN</h4>
            <div className="gallery-section_photo-album">
                <PhotoAlbum source={{ miniImages: SebiArusMiniImg2023, largeImages: SebiArusLargeImg2023 }} />
            </div>

            <h4 className="seciton-title">2022 ŞEB-İ ARUS PROGRAMINDAN</h4>
            <div className="gallery-section_photo-album">
                <PhotoAlbum source={{ miniImages: SebiArusMiniImg2022, largeImages: SebiArusLargeImg2022 }} />
            </div>

            <div className="gallery-section_photo-album">
                {/* <PhotoAlbum sourceImages={Images2018} /> */}
            </div>

            <h3 className="seciton-title">1991 yılından Turgu Özal'lında bulunduğu Sultan Ahmet Meydanı'nda Sema gösterisi</h3>

            <PhotoColumn
                imageSource={sema1}
                imageTitle="Ali Yakub Babacan"
                imageSourceList={[{ src: sema1, width: 300 }, { src: sema1, width: 600 }]}
            />

            <PhotoColumn
                imageSource={sema2}
                imageTitle="Ali Yakub Babacan"
                imageSourceList={[{ src: sema2, width: 300 }, { src: sema2, width: 600 }]}
            />

            <PhotoColumn
                imageSource={sema3}
                imageTitle="Ali Yakub Babacan"
                imageSourceList={[{ src: sema3, width: 300 }, { src: sema3, width: 600 }]}
            />
        </section>
    )
}

export default Gallery;